import algoliasearch from 'algoliasearch/lite';

const searchClient = () => {
  return algoliasearch(
    process.env.REACT_APP_ALGOLIA_APP_ID || '77X6ZYXO7I',
    process.env.REACT_APP_ALGOLIA_API_KEY || 'ef567fd10c908c49fd0f112b1ff30a3e',
  );
};

const initIndex = (indexName) => {
  return searchClient().initIndex(indexName);
};

const multipleQueries = (queries = []) => {
  return searchClient().multipleQueries(queries);
};

export { searchClient, initIndex, multipleQueries };
